import { gql } from '@apollo/client';
const UPDATE_PRODUCT_FUNCTION = gql `
  mutation UpdateProductFunction(
    $productFunctionId: ID!
    $name: String!
    $description: String
    $thumbnail: String
  ) {
    updateProductFunction(
      productFunctionId: $productFunctionId
      name: $name
      description: $description
      thumbnail: $thumbnail
    ) {
      productFunction {
        id
        name
        description
        thumbnail
      }
    }
  }
`;
export default UPDATE_PRODUCT_FUNCTION;
